import { ReportFieldOption } from "./reportFieldOption";

export class ReportOptions{
    reportName   : string;
    fieldOptions : ReportFieldOption[] = [];
}